import { HttpErrorResponse } from '@angular/common/http';
import { ApiError } from '../../models/api-error.model';

export const MSG_GENERICA = 'Ocorreu um erro inesperado. Tente novamente.';
export const MSG_SEM_CONEXAO = 'Não foi possível conectar ao servidor.';

/** `login` indica que o erro vem de /auth/login (onde 403-01 significa usuário inativo). */
export type ContextoErro = 'login';

export function mensagemDeErro(erro: unknown, contexto?: ContextoErro): string {
  if (!(erro instanceof HttpErrorResponse)) {
    return MSG_GENERICA;
  }
  if (erro.status === 0) {
    return MSG_SEM_CONEXAO;
  }
  const corpo = erro.error as Partial<ApiError> | null;
  const code = corpo?.code;
  const message = typeof corpo?.message === 'string' && corpo.message.trim() ? corpo.message : null;

  if (code === '401-02') {
    return 'Usuário ou senha inválidos.';
  }
  if (code === '403-01' && contexto === 'login') {
    return 'Usuário inativo.';
  }
  if (code === '403-02') {
    return 'Você não tem permissão para esta ação.';
  }
  if (code === '429-01') {
    return 'Muitas tentativas. Tente novamente mais tarde.';
  }
  if (code === '409-01') {
    return 'CNPJ já cadastrado.';
  }
  if (code === '400-05') {
    return 'URL inválida ou não permitida.';
  }
  if (code === '409-02') {
    return 'Já existe um registro com este nome.';
  }
  if (code === '409-03') {
    return 'Onboarding incompleto: conclua todas as etapas obrigatórias.';
  }
  if (code === '400-07') {
    return message ?? 'Senha inválida: mínimo de 8 caracteres e diferente da atual.';
  }
  if (code === '409-04') {
    return 'Não é possível: a plataforma ficaria sem administrador ativo.';
  }
  if (code === '409-05') {
    return 'Não é permitido inativar ou rebaixar o seu próprio usuário.';
  }
  if (code === '404-05') {
    return 'Usuário não encontrado.';
  }
  if (code === '400-10') {
    return message ?? 'Dados do tenant inválidos. Revise os campos informados.';
  }
  if (code === '400-11') {
    return 'Nenhum tenant habilitado na onda informada.';
  }
  if (code === '404-08') {
    return 'Tenant não encontrado.';
  }
  if (code === '404-09') {
    return 'Migração não encontrada.';
  }
  if (code === '409-06') {
    return 'Já existe um tenant com este slug.';
  }
  if (code === '409-07') {
    return 'Este cliente já possui um tenant.';
  }
  if (code === '409-09') {
    return 'Transição inválida para o estado atual da migração.';
  }
  if (code === '409-10') {
    return 'Já existe uma migração em execução ou pausada.';
  }
  return message ?? MSG_GENERICA;
}
